<template>
    <div class="box show-frozen-placeholder">
        <svg-vue icon="hosting-benefit" class="placeholder-image" />
        <div class="placeholder-content">
            <h2 class="placeholder-title">
                Your show is frozen ❄️
            </h2>
            <p class="placeholder-text">
                Due to our recent pricing model changes, your Show has been frozen. Please upgrade this show to reactivate your players.
            </p>
            <p class="placeholder-text">
                If you won't reactivate before {{ frozenDeadline }}, your Show will be removed.
            </p>
            <FormButton class="is-purple" @click="reactiveShow">
                Re-activate this Show
            </FormButton>
        </div>
    </div>
</template>
<script>

/**
 * External dependencies.
 */
import { mapState, mapMutations, mapActions } from 'vuex';
import moment from 'moment';

/**
 * Internal dependencies.
 */
import { FormButton } from '@/components/Form';
import { ACTION } from '@/components/ShowModal/config';

export default {
    components: {
        FormButton,
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },

    computed: {
        ...mapState(['currentSubscription']),

        /**
         * Gets the frozen deadline.
         *
         * @returns {string} Frozen deadline.
         */
        frozenDeadline() {
            return moment(this.show.frozenDeadline).format('MMMM Do, YYYY');
        },
    },

    methods: {
        ...mapActions('show/modal', ['openModal']),

        ...mapMutations('show/modal', ['setFreshState', 'setStep', 'setAction', 'setShow']),

        /**
         * Reactivates show.
         */
        reactiveShow() {
            this.openModal();
            this.setFreshState();
            this.setAction(ACTION.RENEW);
            this.setShow(this.show);
        },
    },
};
</script>
<style scoped lang="scss">
    @use './ShowFrozenPlaceholder.scss';
</style>
